export type TaskAction =
  | 'openDocuments'
  | 'openFinance'
  | 'openDispatch'
  | 'openClientDocsSend'
  | 'openClientDocsReceive'
  | 'sendInvoiceToClient'
  | 'openClosingPackageModal';

export const TASK_REGISTRY: Record<string, {
  label: string;
  role: string;
  action: TaskAction;
  actionLabel?: string;
  severity: string;
}> = {
  LOADING_PHOTO: {
    label: 'Загрузить фото погрузки',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Загрузить фото',
    severity: 'warning'
  },
  /** Алиас к типу погрузки (если придёт с бэкенда) */
  UPLOAD_LOADING_PHOTO: {
    label: 'Загрузить фото погрузки',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Загрузить фото',
    severity: 'warning'
  },
  UNLOADING_PHOTO: {
    label: 'Загрузить фото выгрузки',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Фото выгрузки',
    severity: 'warning'
  },
  LOADING_DOCUMENTS_UPLOAD: {
    label: 'Загрузить документы погрузки',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Загрузить документы',
    severity: 'warning'
  },
  UNLOADING_DOCUMENTS_UPLOAD: {
    label: 'Загрузить документы выгрузки',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Загрузить документы',
    severity: 'warning'
  },
  RAIL_WAYBILL_MISSING: {
    label: 'Загрузить ж/д накладную',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Загрузить накладную',
    severity: 'warning'
  },
  AWB_MISSING: {
    label: 'Загрузить авианакладную',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Загрузить AWB',
    severity: 'warning'
  },
  NO_DOCS_UNLOADING: {
    label: 'Добавить документы выгрузки',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Добавить документы',
    severity: 'warning'
  },
  GROUP_DOCS_INCOMPLETE: {
    label: 'Не все документы по заявке',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Добавить документы',
    severity: 'warning'
  },
  TN_ORIGINAL_MISSING: {
    label: 'Загрузить оригинал ТН',
    role: 'accountant',
    action: 'openDocuments',
    actionLabel: 'Загрузить оригинал',
    severity: 'critical'
  },
  UPLOAD_TN_ORIGINAL: {
    label: 'Получены оригиналы ТН',
    role: 'accountant',
    action: 'openDocuments',
    actionLabel: 'Загрузить документ',
    severity: 'critical'
  },
  CARRIER_INVOICE_MISSING: {
    label: 'Добавить счет перевозчика',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Добавить счёт',
    severity: 'warning'
  },
  CARRIER_INVOICE_CONFIRM: {
    label: 'Подтвердить счёт перевозчика',
    role: 'logist/accountant',
    action: 'openFinance',
    actionLabel: 'Подтвердить',
    severity: 'warning'
  },
  INVOICE_EXPECTED: {
    label: 'Добавить счет перевозчика',
    role: 'logist',
    action: 'openDocuments',
    actionLabel: 'Добавить счёт',
    severity: 'warning'
  },
  UPD_UPLOAD: {
    label: 'Загрузить УПД',
    role: 'accountant',
    action: 'openDocuments',
    actionLabel: 'Загрузить УПД',
    severity: 'warning'
  },
  UPD_CONFIRM: {
    label: 'Подтвердить УПД',
    role: 'logist/accountant',
    action: 'openDocuments',
    actionLabel: 'Подтвердить',
    severity: 'warning'
  },
  PAYMENT_EXPECTED: {
    label: 'Ожидается оплата',
    role: 'accountant',
    action: 'openFinance',
    actionLabel: 'Оплата и финансы',
    severity: 'critical'
  },
  EXPENSE_CONFIRMATION: {
    label: 'Подтвердить расходы по маршруту',
    role: 'accountant',
    action: 'openFinance',
    actionLabel: 'Проверить расходы',
    severity: 'warning'
  },
  /** Подпись в TaskCard переопределяется: «Провести платеж — Предоплата/Доплата» */
  CLIENT_PAYMENT_DUE: {
    label: 'Провести платеж',
    role: 'accountant',
    action: 'openFinance',
    actionLabel: 'Открыть финансы',
    severity: 'critical'
  },
  CLIENT_DOCS_SENT: {
    label: 'Отправить документы клиенту',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'К заявке',
    severity: 'info'
  },
  ORIGINALS_SENT: {
    label: 'Отправить оригиналы',
    role: 'logist',
    action: 'openClientDocsSend',
    actionLabel: 'Отправить оригиналы',
    severity: 'warning'
  },
  CLIENT_DOCS_RECEIVED: {
    label: 'Подтвердить получение клиентом',
    role: 'logist',
    action: 'openClientDocsReceive',
    actionLabel: 'Подтвердить получение',
    severity: 'info'
  },
  // CREATED stage — заполнить данные маршрута (openDispatch → navigate to route)
  MISSING_CARRIER: {
    label: 'Указать перевозчика',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Добавить перевозчика',
    severity: 'warning'
  },
  ADD_CARRIER: {
    label: 'Указать перевозчика',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Добавить перевозчика',
    severity: 'warning'
  },
  MISSING_PRICE: {
    label: 'Указать сумму',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Указать сумму',
    severity: 'warning'
  },
  MISSING_RESPONSIBLE: {
    label: 'Назначить ответственного',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Назначить ответственного',
    severity: 'warning'
  },
  MISSING_CONTRACT: {
    label: 'Указать договор',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Указать договор',
    severity: 'warning'
  },
  SEND_INVOICE_TO_CLIENT: {
    label: 'Отправить счёт клиенту',
    role: 'logist',
    action: 'sendInvoiceToClient',
    actionLabel: 'Отправить счёт',
    severity: 'warning'
  },
  SEND_INVOICE: {
    label: 'Отправить счёт клиенту',
    role: 'logist',
    action: 'sendInvoiceToClient',
    actionLabel: 'Отправить счёт',
    severity: 'warning'
  },
  SEND_ORIGINAL_TN: {
    label: 'Отправить оригиналы ТН',
    role: 'logist/accountant',
    action: 'openDocuments',
    actionLabel: 'К документам',
    severity: 'warning'
  },
  CREATE_CLIENT_INVOICE: {
    label: 'Создать счет клиенту',
    role: 'accountant',
    action: 'openFinance',
    actionLabel: 'Выставить счет',
    severity: 'warning'
  },
  CONFIRM_INVOICE_SENT: {
    label: 'Подтвердить отправку счета',
    role: 'logist/accountant',
    action: 'openDispatch',
    actionLabel: 'Открыть задачу',
    severity: 'warning'
  },
  UPLOAD_LOADING_DOCS: {
    label: 'Загрузить документы погрузки',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Загрузить',
    severity: 'info'
  },
  UPLOAD_UNLOADING_DOCS: {
    label: 'Загрузить документы выгрузки',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Загрузить',
    severity: 'info'
  },
  UPLOAD_UPD: {
    label: 'Загрузить УПД',
    role: 'accountant',
    action: 'openDispatch',
    actionLabel: 'Загрузить УПД',
    severity: 'info'
  },
  CONFIRM_UPD_SENT: {
    label: 'Подтвердить отправку УПД',
    role: 'logist',
    action: 'openDispatch',
    actionLabel: 'Открыть задачу',
    severity: 'warning'
  },
  FORM_CLOSING_PACKAGE: {
    label: 'Сформировать комплект закрывающих документов',
    role: 'accountant',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  SEND_SCANS_TO_CLIENT: {
    label: 'Отправить сканы комплекта клиенту',
    role: 'logist',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  SEND_CLOSING_PACKAGE_SCANS: {
    label: 'Отправить сканы комплекта клиенту',
    role: 'logist',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  WAIT_CLIENT_APPROVAL: {
    label: 'Ожидание согласования комплекта клиентом',
    role: 'logist',
    action: 'openClosingPackageModal',
    actionLabel: 'Зарегистрировать ответ',
    severity: 'processing',
  },
  REVISE_CLOSING_PACKAGE: {
    label: 'Доработать комплект закрывающих документов',
    role: 'accountant',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'error',
  },
  PREPARE_ORIGINALS: {
    label: 'Подготовить оригиналы комплекта',
    role: 'accountant',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  SEND_ORIGINALS: {
    label: 'Отправить оригиналы комплекта клиенту',
    role: 'logist/accountant',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  SEND_CLOSING_PACKAGE_ORIGINALS: {
    label: 'Отправить оригиналы комплекта клиенту',
    role: 'logist/accountant',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  CONFIRM_CLIENT_RECEIPT: {
    label: 'Подтвердить получение оригиналов комплекта',
    role: 'logist',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  SEND_VIA_EDO: {
    label: 'Отправить документы через ЭДО',
    role: 'accountant',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
  CONFIRM_EDO_RECEIPT: {
    label: 'Подтвердить получение документов по ЭДО',
    role: 'accountant',
    action: 'openClosingPackageModal',
    actionLabel: 'Открыть задачу',
    severity: 'warning',
  },
};
